<div *ngIf="hasSchedules" class="branch-schedule">

  <div class="schedule-grid">
    <div *ngFor="let schedule of sortedSchedules"
         class="schedule-row"
         [class.is-closed]="!schedule.isOpen">
      <span class="day">{{ 'schedule.days.' + schedule.dayOfWeek | translate }}</span>
      <span *ngIf="schedule.isOpen" class="hours">
        {{ formatTime(schedule.openTime) }}&nbsp;&ndash;&nbsp;{{ formatTime(schedule.closeTime) }}
      </span>
      <span *ngIf="!schedule.isOpen" class="closed">{{ 'schedule.closed' | translate }}</span>
    </div>
  </div>

  <div *ngIf="showDrinkHoppingTip" class="dh-tip">
    <span class="dh-tip-label">{{ 'schedule.dhRecommends' | translate }}</span>
    {{ 'schedule.dhTip' | translate }}
  </div>

  <p class="disclaimer">{{ 'schedule.disclaimer' | translate }}</p>

</div>
